import React, { useEffect } from "react";
import AlertModal from '../../AlertModal';
import { useSelector, useDispatch } from "react-redux";
import { useCallbackContext } from "../../../../contexts/CallbackContext";
import { clearSweetConfig } from "../../../../features/sweetAlert/sweetAlertSlice";

const SweetAlertContainer = () => {
    const { isVisible, config } = useSelector(state => state.sweetAlert);
    const { getCallback, unregisterCallback } = useCallbackContext();
    const dispatch = useDispatch();

    useEffect(() => {
        const confirmKey = config.onConfirmKey;
        const cancelKey = config.onCancelKey;
        const closeKey = config.onCloseKey;

        return () => {
            if (confirmKey) {
                unregisterCallback(confirmKey);
            }
            if (cancelKey) {
                unregisterCallback(cancelKey);
            }
            if (closeKey) {
                unregisterCallback(closeKey);
            }
        };
    }, []);

    const handleConfirm = async () => {
        // Handle special case for ERROR_LOG_CLOSE
        if (config.onConfirmKey === 'ERROR_LOG_CLOSE') {
            dispatch(clearSweetConfig());
            return;
        }

        const confirmCallback = getCallback(config.onConfirmKey);
        if (confirmCallback) {
            await confirmCallback();
        }
    };

    const handleCancel = async () => {
        const cancelCallback = getCallback(config.onCancelKey);
        if (cancelCallback) {
            await cancelCallback();
        }
    };

    const handleClose = async () => {
        const closeCallback = getCallback(config.onCloseKey);
        if (closeCallback) {
            await closeCallback();
        }
    };

    // Map alert type - convert 'danger' to 'error'
    const alertType = config.type === 'danger' ? 'error' : config.type;

    // Determine button visibility
    const showConfirm = config.showOkBtn || config.showConfirmBtn;
    const showCancel = !config.showOkBtn && config.showCancelBtn;

    // Determine button text with loading states
    const confirmText = config.showOkBtn ? 'OK' : (
        config.okLoading ? (
            <>
                <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                &nbsp;&nbsp;{config.textWhileProcessingConfirmBtn || 'Processing...'}
            </>
        ) : config.confirmBtnText
    );

    const cancelText = config.noLoading ? (
        <>
            <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
            &nbsp;&nbsp;{config.textWhileProcessingCancelBtn || 'Processing...'}
        </>
    ) : config.cancelBtnText;

    // Disable buttons when loading
    const disabled = config.okLoading || config.noLoading;

    // Support both old and new property names for backward compatibility
    const confirmCssClass = config.confirmBtnCssClass || config.confirmBtnCss || '';
    const cancelCssClass = config.cancelBtnCssClass || config.cancelBtnCss || '';

    return (
        <AlertModal
            show={isVisible}
            type={alertType}
            title={config.title}
            confirmBtnText={confirmText}
            cancelBtnText={cancelText}
            showConfirm={showConfirm}
            showCancel={showCancel}
            showCloseButton={config.showCloseBtn}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            onClose={handleClose}
            closeOnClickOutside={config.closeOnClickOutside || false}
            confirmBtnCssClass={confirmCssClass}
            cancelBtnCssClass={cancelCssClass}
            disabled={disabled}
        >
            {config.message}
        </AlertModal>
    );
};

export default SweetAlertContainer;
